module.exports = __webpack_public_path__ + "img/callendar-gray.633b42e8.svg";